var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 121,
    viewBox: "0 0 62 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3156 88.5419C61.3156 105.685 46.9852 120.13 29.8424 120.13C17.234 120.13 5.71612 112.419 0.339844 99.6771L6.3475 97.1133C10.748 107.636 19.7021 113.51 29.8615 113.51C43.8284 113.51 54.8488 102.49 54.8488 88.5419C54.8488 74.5942 43.8284 63.4398 29.8615 63.4398L28.9623 59.4411L29.8615 59.2689C43.8284 56.8199 54.8488 45.7995 54.8488 31.7179C54.8488 17.6363 43.8284 6.74978 29.8615 6.74978C19.7021 6.74978 10.7671 12.6235 6.3475 23.1465L0.339844 20.5827C5.73525 7.84034 17.234 0.129883 29.8424 0.129883C46.9852 0.129883 61.3156 14.575 61.3156 31.7179C61.3156 45.0534 52.7442 56.686 44.058 60.1299C52.7442 63.5546 61.3156 75.1873 61.3156 88.5419Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/NUMBER_3.495eb89f2866ded9c0564bdfdaa2d779.svg";
export { ForwardRef as ReactComponent };